import { Constants } from "../api-communication/ApiConstants";
import axios from "axios";
let axios_instance;
let dicom_axios_instance;

export function setAxiosInstance(instance) {
  axios_instance = instance;
}

export function createAxiosInstance() {
  const path = Constants.instance.REST_API_URL;
  const dicom_path = Constants.instance.DICOM_SERVER_URL;
  console.log("creating axios");
  console.log("axios path: ", path);
  console.log("dicom path: ", dicom_path);

  const envTimeout = parseInt(process.env.REACT_APP_AXIOS_TIMEOUT);
  const timeout = isNaN(envTimeout) ? 15000 : envTimeout;

  axios_instance = axios.create({
    baseURL: path,
    timeout,
  });

  dicom_axios_instance = axios.create({
    baseURL: dicom_path,
    timeout,
  });
}

export function getDicomAxiosInstance() {
  if (!dicom_axios_instance) {
    throw new Error("Dicom Axios instance not created. Call createAxiosInstance first.");
  }
  console.log("axios dicom base path: ", dicom_axios_instance.config);
  return dicom_axios_instance;
}

export function getAxiosInstance() {
  // console.log("Fetched Axios Instance: ", JSON.stringify(axios_instance, null, 2));
  return axios_instance;
}
